import React from "react";
import { Mail, Users, Sparkles } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Badge } from "@/components/ui/badge";
import { openAppOrWeb } from "@/lib/openAppOrWeb";
import { openAnnouncement } from "@/lib/announcement";

// Mobile-only launcher row; on desktop these live in the header.
export const MobileAppLaunchers: React.FC = () => {
  const { t } = useLanguage();

  const tileClass =
    "flex flex-col items-center justify-center gap-2 rounded-xl border border-border bg-card p-3 text-sm font-medium transition-colors";

  return (
    <div className="grid grid-cols-3 gap-3 md:hidden">
      <button
        type="button"
        onClick={() =>
          openAppOrWeb("ms-outlook://", "https://outlook.office.com/mail/")
        }
        className={`${tileClass} hover:bg-accent`}
      >
        <Mail className="h-6 w-6 text-primary" />
        {t("nav.outlook")}
      </button>

      <button
        type="button"
        onClick={() => openAppOrWeb("msteams:", "https://teams.microsoft.com/")}
        className={`${tileClass} hover:bg-accent`}
      >
        <Users className="h-6 w-6 text-primary" />
        {t("nav.teams")}
      </button>

      {/* Wasmi (company AI chat) - not launched yet */}
      <button
        type="button"
        onClick={openAnnouncement}
        className={`${tileClass} hover:bg-accent`}
        title={`${t("nav.wasmi")} - ${t("common.coming_soon")}`}
      >
        <Sparkles className="h-6 w-6 text-primary" />
        {t("nav.wasmi")}
        <Badge variant="secondary" className="px-1.5 py-0 text-[10px] font-normal">
          {t("common.coming_soon")}
        </Badge>
      </button>
    </div>
  );
};
